package team.platforma.auth_domain.model


data class AuthDomain(
    val account: Account,
    val jwt: Jwt
) {
    data class Jwt(
        val refreshToken: String,
        val refreshTokenExpires: Long,
        val token: String,
        val tokenExpires: Long
    )

    data class Account(
        val accountId: Long,
        val createdAt: String,
        val email: String,
        val firstName: String,
        val isAdmin: Boolean,
        val lastName: String,
        val telegramChatId: Long?
    )
}





